/* Church Sign Shop — FAQ accordion toggle. */
(function () {
  function init() {
    var items = document.querySelectorAll('.faq-item');
    for (var i = 0; i < items.length; i++) {
      (function (item) {
        var btn = item.querySelector('.faq-item__q');
        if (!btn) return;
        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          item.classList.toggle('is-open', !isOpen);
          btn.setAttribute('aria-expanded', String(!isOpen));
        });
      })(items[i]);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
